import useDirectories from 'hooks/student/useDirectories';

export default function DirectoriesLoader({ children }) {
  const { isLoading } = useDirectories();
  return isLoading ? <div>Loading...</div> : children;
}
